import { ModelResource } from './resource';
import { BankAccount } from '../models';

export class BankAccounts extends ModelResource<BankAccount> {
  model = BankAccount;

  resourcePath = 'v1/bank-accounts';
}
